import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';

export default function SectionA3() {
    const { t } = useLang('delta_pro_ultra.launch.detail.SectionA3');

    return (
        <div className={`page-sectionA3 ${styles.SectionA3}`}>
            <EcoSpace />
            <EcoSectionCommon title={t('title')} desc={t('desc')} />
            <EcoSpaceSmall />
            <div className={`eco-content ${styles.SectionA3}`}>
                <EcoImg className="product-img" pc="https://websiteoss.ecoflow.com/upload/image/1749177909515/take%20you%20anywhere.png" />
                <div className="tip">{t('tip')}</div>
            </div>
        </div>
    );
}
